export default __webpack_public_path__ + "assets/webgl/skybox_end.1eeb835b.jpg";